import { INativeProgramResponse, ISortProgramById, KeyValue, Role } from '@carm/_core';
import { SortDirection } from './models';

Array.prototype.sortByValue = function(sortDirection: SortDirection = SortDirection.Ascending): KeyValue[] {
  if (sortDirection === SortDirection.Descending) {
    return this.sort((a, b) => b.value.localeCompare(a.value));
  } else {
    return this.sort((a, b) => a.value.localeCompare(b.value));
  }
};

Array.prototype.sortByKey = function(sortDirection: SortDirection = SortDirection.Ascending): KeyValue[] {
  if (sortDirection === SortDirection.Descending) {
    return this.sort((a, b) => (a.key > b.key) ? -1 : 1);
  } else {
    return this.sort((a, b) => (a.key > b.key) ? 1 : -1);
  }
};

Array.prototype.prefixDisplayWithKey = function(): KeyValue[] {
  // display as 'theKey - theValue'
  return this.map(t => ({ ...t, value: `${t.key && t.key != '-' ? t.key + ' - ': ''} ${t.value || ''}`} as KeyValue));
};

Array.prototype.distinct = function(distinctOnProperty: string = 'value'): KeyValue[] {
  return [...new Map(this.map(item => [item[distinctOnProperty], item])).values()];
}

Array.prototype.distinctList = function(): string[] {
  return this.filter((current, index) => this.indexOf(current) === index);
}

Array.prototype.sortStrings = function(sortDirection: SortDirection = SortDirection.Ascending): string[] {
  if (sortDirection === SortDirection.Descending) {
    return this.sort((a, b) => (a > b) ? -1 : 1);
  } else {
    return this.sort((a, b) => (a > b) ? 1 : -1);
  }
};

Array.prototype.sortNativePrograms = function(): INativeProgramResponse[] {
  return this.sort(
    (a: INativeProgramResponse, b: INativeProgramResponse) =>
      parseInt(a.uid?.substr(a.uid.length - 4, 4), 10) -
      parseInt(b.uid?.substr(b.uid.length - 4, 4), 10)
  );
};

Array.prototype.sortRoleByProgramRM = function(): Role[] {
  return this.sort((a, b) => (a.program.uid.substring(9) > b.program.uid.substring(9)) ? 1 : -1);
};

Array.prototype.hasErrorCode = function(code: string): boolean {
  const error = this.find(mappedError => mappedError?.value?.errors?.find(e => e.code === code));
  return !!error;
};

Array.prototype.sortByProgramNumber = function(): ISortProgramById[] {
  return this?.sort(
    (a: ISortProgramById, b: ISortProgramById) =>
      parseInt(a.uid?.substr(a.uid.length - 4, 4), 10) -
      parseInt(b.uid?.substr(b.uid.length - 4, 4), 10)
  );
};

Array.prototype.sortByDate = function(dateFieldName: string, ascending: boolean = true): any[] {
  return this?.sort(
    (a: any, b: any) => {
      let first = new Date(a[dateFieldName]).getTime();
      let second = new Date(b[dateFieldName]).getTime();
      return ascending ? first - second : second - first;
    }
  );
};
